import React, { useContext, useEffect, useState } from "react";
import axios from "axios"
import { Smile, Bold, Italic, Underline, Code } from "lucide-react";
import SampleModel from "./SampleModel";
import { useAPI } from "../../Context/MyContext";
import { useStateContex } from "../../Context/UseStateContet";
import { set } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

function TemplateContent({ template, setTemplate, setMediaPreview, setVarType, setShowPreview, mediaPreview, setMediaId }) {
  const navigate = useNavigate();
  const {wabaId, phoneNumberId} = useParams()
  const [variableType, setVariableType] = useState("Number");
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  const [footer, setFooter] = useState("");
  const [mediaType, setMediaType] = useState("None");
  const [mediaFile, setMediaFile] = useState(null);
  const [uploadedMediaId, setUploadedMediaId] = useState(null);
  const [selectedPhone, setSelectedPhone] = useState();
  const [phones, setPhones] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { selectedWabaId, selectedPhoneNumberId } = useStateContex()

  if (!wabaId || !phoneNumberId) {
    navigate("/template");
  }
  // Variable counters for Number type
  const [variableCounters, setVariableCounters] = useState({
    header: 1,
    body: 1,
    footer: 1 
  });


  // Variable samples for preview
  const [variableSamples, setVariableSamples] = useState({});


  const [validation, setValidation] = useState({
    header: { isValid: true, errors: {} },
    body: { isValid: true, errors: {} },
    footer: { isValid: true, errors: {} }
  });
  const emojis = ["😀", "😂", "😍", "🤔", "👍", "👏", "🔥", "❤️", "✅"];
  const { uploadTemplateMedia, getPhoneAll, } = useAPI();

  // Fetch phones on mount
  useEffect(() => {
    const fetchPhones = async () => {
      try {
        const res = await getPhoneAll();
        if (res?.success) {
          setPhones(res.data);
          if (res.data.length > 0) {
            setSelectedPhone(res.data[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching phones:", err);
      }
    };
    fetchPhones();
  }, []);


  // const extractVariables = (text) => {
  //   const matches = text.match(/{{(.*?)}}/g) || [];
  //   return matches.map(match => match.slice(2, -2).trim());
  // };

  // Extract variables
  const extractVariables = (text = "") => {
    const matches = text.match(/{{(.*?)}}/g) || [];
    return matches.map(match => match.slice(2, -2).trim());
  };


  // Count real words only
  const countWords = (text = "") => {
    return (
      text
        .replace(/{{.*?}}/g, " ")
        .trim()
        .split(/\s+/)
        .filter(word => /[a-zA-Z0-9]/.test(word)).length
    );
  };


  // Validate variables in text
  // const validateVariables = (text, fieldType) => {
  //   const variables = extractVariables(text);



  //   if (variables.length === 0) {
  //     return { isValid: true, message: "" };
  //   }


  //   // ❗ NEW RULE: variable can't be at start or end (only for body)
  //   if (fieldType === "body") {
  //     const trimmed = text.trim();
  //     const withoutVars = trimmed.replace(/{{.*?}}/g, "");

  //     const errors = {
  //       startEnd: false,
  //       ratio: false,
  //     };

  //     // --- RULE 1: start/end variable rule (STRICT FIX)
  //     const startsWithVar = /^{{\d+}}/.test(trimmed);
  //     const endsWithVar = /{{\d+}}$/.test(trimmed);

  //     const hasRealText = /[a-zA-Z0-9]/.test(withoutVars);

  //     if (!hasRealText || startsWithVar || endsWithVar) {
  //       errors.startEnd = true;
  //     }

  //     // --- RULE 2: ratio rule
  //     const variables = extractVariables(text);
  //     const variableCount = variables.length;

  //     const words = withoutVars
  //       .split(/\s+/)
  //       .filter(w => /[a-zA-Z0-9]/.test(w));

  //     const wordCount = words.length;

  //     if (variableCount > 0 && wordCount < variableCount * 2) {
  //       errors.ratio = true;
  //     }

  //     const isValid = !errors.startEnd && !errors.ratio;

  //     return {
  //       isValid,
  //       errors,
  //     };
  //   }

  //   // Header can only have one variable
  //   if (fieldType === 'header' && variables.length > 1) {
  //     return {
  //       isValid: false,
  //       message: "Header can only contain one variable."
  //     };
  //   }

  //   // Validate based on variable type
  //   let isValid = true;
  //   let message = "";

  //   if (variableType === "Number") {
  //     // Check if all variables are numeric
  //     const invalidVars = variables.filter(v => !/^\d+$/.test(v));
  //     if (invalidVars.length > 0) {
  //       isValid = false;
  //       message = "This template contains variable parameters with incorrect formatting. Variable parameters must be lowercase characters, underscores and numbers with two sets of curly brackets (for example, {{customer_name}}, {{order_id}}).";
  //     }
  //   } else if (variableType === "Name") {
  //     // Check if all variables are valid names (letters, underscores, numbers)
  //     const invalidVars = variables.filter(v => v !== "" && !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(v));
  //     if (invalidVars.length > 0) {
  //       isValid = false;
  //       message = "This template contains variable parameters with incorrect formatting. Variable parameters must be lowercase characters, underscores and numbers with two sets of curly brackets (for example, {{customer_name}}, {{order_id}}).";
  //     }
  //   }

  //   return { isValid, message };
  // };

  // Validate variables
  const validateVariables = (text = "", fieldType) => {
    const variables = extractVariables(text);

    const result = {
      isValid: true,
      message: "",
      errors: {
        startEnd: false,
        ratio: false,
        formatting: false,
        headerLimit: false,
      },
    };

    // No variables = valid
    if (variables.length === 0) {
      return result;
    }

    // =========================
    // HEADER RULE
    // =========================
    if (fieldType === "header" && variables.length > 1) {
      result.isValid = false;
      result.errors.headerLimit = true;
      result.message = "Header can only contain one variable.";
      return result;
    }

    // =========================
    // VARIABLE FORMAT VALIDATION
    // =========================
    if (variableType === "Number") {
      const invalidVars = variables.filter(v => !/^\d+$/.test(v));

      if (invalidVars.length > 0) {
        result.isValid = false;
        result.errors.formatting = true;
        result.message =
          "Variables must use numeric format like {{1}}, {{2}}.";
        return result;
      }
    }

    if (variableType === "Name") {
      const invalidVars = variables.filter(
        v => !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(v)
      );

      if (invalidVars.length > 0) {
        result.isValid = false;
        result.errors.formatting = true;
        result.message =
          "Variables must contain only letters, numbers and underscores.";
        return result;
      }
    }

    // =========================
    // BODY RULES
    // =========================
    if (fieldType === "body") {
      const trimmed = text.trim();

      // Detect start/end variables safely
      const startsWithVariable = /^{{[^}]+}}/.test(trimmed);

      const endsWithVariable = /{{[^}]+}}[.!?]?$/.test(trimmed);

      // Remove variables to check real surrounding text
      const plainText = trimmed
        .replace(/{{.*?}}/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      const hasRealText = /[a-zA-Z0-9]/.test(plainText);

      // RULE 1:
      // Variable cannot be at start/end
      if (
        !hasRealText ||
        startsWithVariable ||
        endsWithVariable
      ) {
        result.isValid = false;
        result.errors.startEnd = true;
      }

      // RULE 2:
      // Meta prefers enough words around variables
      // approx 3 words per variable
      const wordCount = countWords(text);
      const variableCount = variables.length;

      // if (wordCount < variableCount * 3) {
      if (wordCount <= variableCount * 2) {
        result.isValid = false;
        result.errors.ratio = true;
      }
    }

    return result;
  };


  useEffect(() => {
    const headerValidation = validateVariables(header, "header");
    const bodyValidation = validateVariables(body, "body");
    const footerValidation = validateVariables(footer, "footer");

    setValidation({
      header: headerValidation,
      body: bodyValidation,
      footer: footerValidation,
    });
  }, [header, body, footer, variableType]);

  // Add variable to specific field
  const handleAddVariable = (fieldType) => {
    let newVariable;

    if (variableType === "Number") {
      newVariable = `{{${variableCounters[fieldType]}}}`;
      setVariableCounters(prev => ({
        ...prev,
        [fieldType]: prev[fieldType] + 1
      }));
    } else {
      // For Name type, use a generic placeholder
      newVariable = "{{name}}";
    }

    // Check header limitation
    if (fieldType === 'header') {
      const currentVars = extractVariables(header);
      if (currentVars.length >= 1) {
        setValidation(prev => ({
          ...prev,
          header: { isValid: false, message: "Header can only contain one variable." }
        }));
        return;
      }
      setHeader(prev => prev + newVariable);
    } else if (fieldType === 'body') {
      setBody(prev => prev + newVariable);
    } else if (fieldType === 'footer') {
      setFooter(prev => prev + newVariable);
    }
  };

  // Enhanced file upload handler from original code
  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];

    // Reset states
    setMediaFile(file);
    setUploadedMediaId(null);
    setMediaPreview("https://placehold.co/280x160?text=Preview");

    if (!file) return;

    // Enhanced file type validation
    const allowedImageTypes = ["image/jpeg", "image/jpg", "image/png"];
    const allowedVideoTypes = ["video/mp4", "video/3gpp"];
    const allowedDocumentTypes = ["application/pdf"];

    const isValidImage = allowedImageTypes.includes(file.type);
    const isValidVideo = allowedVideoTypes.includes(file.type);
    const isValidDocument = allowedDocumentTypes.includes(file.type);

    if (!isValidImage && !isValidVideo && !isValidDocument) {
      alert(
        `Unsupported file type: ${file.type}. Please upload JPEG, PNG, MP4, 3GPP, or PDF files only.`
      );
      e.target.value = "";
      return;
    }

    // Enhanced size validation
    const sizeLimits = {
      image: 5 * 1024 * 1024, // 5MB
      video: 16 * 1024 * 1024, // 16MB
      document: 100 * 1024 * 1024, // 100MB
    };

    let maxSize, fileCategory;
    if (isValidImage) {
      maxSize = sizeLimits.image;
      fileCategory = "image";
    } else if (isValidVideo) {
      maxSize = sizeLimits.video;
      fileCategory = "video";
    } else if (isValidDocument) {
      maxSize = sizeLimits.document;
      fileCategory = "document";
    }

    if (file.size > maxSize) {
      const maxSizeMB = Math.round(maxSize / (1024 * 1024));
      const fileSizeMB = Math.round(file.size / (1024 * 1024));
      alert(
        `File too large (${fileSizeMB}MB). Maximum size for ${fileCategory}s is ${maxSizeMB}MB.`
      );
      e.target.value = "";
      return;
    }

    if (!selectedPhone?.waba_id) {
      alert("Please select a phone number before uploading media.");
      e.target.value = "";
      return;
    }

    if (!mediaType) {
      alert("Please select a media type before uploading.");
      e.target.value = "";
      return;
    }

    // Show loading state
    setIsUploading(true);
    setMediaPreview(null);

    try {
      // Show preview immediately (local blob for images/videos)
      if (isValidImage || isValidVideo) {
        const previewUrl = URL.createObjectURL(file);
        setMediaPreview(previewUrl);
        setTimeout(() => URL.revokeObjectURL(previewUrl), 10000);
      } else {
        setMediaPreview("file");
      }

      // Prepare formData
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", mediaType.toLowerCase());
      // formData.append("phone_number_id", selectedPhone.phone_number_id);
      // formData.append("phone_number_id", selectedPhoneNumberId);
      formData.append("phone_number_id", phoneNumberId);
      formData.append("template_name", template?.name);
      // formData.append("wabaId", selectedWabaId);
      formData.append("wabaId", wabaId);
      // formData.append("user_id")



      // Upload with timeout
      const uploadPromise = uploadTemplateMedia(formData);
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Upload timeout")), 30000)
      );

      const data = await Promise.race([uploadPromise, timeoutPromise]);

      if (!data?.success) {
        throw new Error(data?.error?.message || "Upload failed - no success response");
      }

      const mediaId =  data?.media_handle;
      setMediaId(data?.media_id);
      if (!mediaId) throw new Error("Server response missing media identifier");
      // console.log("Message mediaId received:", mediaId);





      setUploadedMediaId(mediaId);
      setShowPreview(true);

      // console.log("Upload successful:", mediaId);
    } catch (err) {
      console.error("Upload error:", err);
      if (err?.message) {
        // console.log(`Upload failed: ${err.message}`);
      }
      setMediaPreview("error"); // flag for failed
    } finally {
      setIsUploading(false);
    }
  };

  const handleDiscardMedia = () => {
    setMediaFile(null);
    setMediaPreview(null);
    setUploadedMediaId(null);
    setShowPreview(false);
    setIsUploading(false);
    const fileInput = document.getElementById("fileInput");
    if (fileInput) fileInput.value = "";
  };

  // Text formatting
  const applyFormat = (type) => {
    const textarea = document.getElementById("bodyTextArea");
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    if (start === end) return;

    const selectedText = body.slice(start, end);
    let formattedText = selectedText;

    switch (type) {
      case "bold":
        formattedText = `**${selectedText}**`;
        break;
      case "italic":
        formattedText = `*${selectedText}*`;
        break;
      case "underline":
        formattedText = `__${selectedText}__`;
        break;
      case "code":
        formattedText = `\`${selectedText}\``;
        break;
    }

    const newValue = body.slice(0, start) + formattedText + body.slice(end);
    setBody(newValue);

    setTimeout(() => {
      textarea.selectionStart = start;
      textarea.selectionEnd = start + formattedText.length;
      textarea.focus();
    }, 0);
  };

  const addEmoji = (emoji) => {
    setBody(prev => prev + emoji);
    setShowEmojiPicker(false);
  };

  // Generate template components for API payload
  const generateTemplateComponents = () => {
    const components = [];

    // HEADER component
    if (header.trim() || mediaType !== "None") {
      const headerComponent = { type: "HEADER" };

      if (mediaType !== "None") {
        // Media header
        headerComponent.format = mediaType.toUpperCase();
        if (uploadedMediaId) {
          headerComponent.example = { header_handle: [uploadedMediaId] };
        }
      } else if (header.trim()) {
        // Text header
        headerComponent.format = "TEXT";
        headerComponent.text = header;

        const headerVars = extractVariables(header);
        if (headerVars.length > 0) {
          if (variableType === "Name") {
            headerComponent.example = {
              header_text_named_params: headerVars.map((v) => ({
                param_name: v,
                example: variableSamples[`header-${v}`] || `Sample ${v}`,
              })),
            };
          } else {
            // wrap inside array for consistency
            headerComponent.example = {
              header_text: [
                headerVars.map(
                  (v) => variableSamples[`header-${v}`] || `Sample ${v}`
                ),
              ],
            };
          }
        }
      }

      components.push(headerComponent);
    }

    // BODY component
    if (body.trim()) {
      const bodyComponent = { type: "BODY", text: body };

      const bodyVars = extractVariables(body);
      if (bodyVars.length > 0) {
        if (variableType === "Name") {
          bodyComponent.example = {
            body_text_named_params: bodyVars.map((v) => ({
              param_name: v,
              example: variableSamples[`body-${v}`] || `Sample ${v}`,
            })),
          };
        } else {
          // FIX: wrap inside outer array
          bodyComponent.example = {
            body_text: [
              bodyVars.map(
                (v) => variableSamples[`body-${v}`] || `Sample ${v}`
              ),
            ],
          };
        }
      }

      components.push(bodyComponent);
    }

    // FOOTER component
    if (footer.trim()) {
      components.push({
        type: "FOOTER",
        text: footer,
      });
    }

    return components;
  };



  // Update template when content changes - matches original pattern exactly
  useEffect(() => {
    const components = generateTemplateComponents();
    setTemplate(prev => ({
      ...prev,
      components
    }));
  }, [header, body, footer, mediaType, uploadedMediaId, variableSamples]);



  const handleBodyChange = (e) => {
    const val = e.target.value;

    // Detect if user is deleting
    if (val.length < body.length) {
      setBody(val);
      return;
    }

    let updatedVal = val;

    if (variableType === "Number") {
      // Only trigger when user just typed {{
      if (updatedVal.endsWith("{{")) {
        const completeMatches = updatedVal.match(/{{\d+}}/g) || [];

        let nextNumber = 1;
        if (completeMatches.length > 0) {
          const nums = completeMatches.map(v =>
            parseInt(v.replace(/[{}]/g, ""))
          );
          nextNumber = Math.max(...nums) + 1;
        }

        // Replace ONLY the last {{
        updatedVal =
          updatedVal.slice(0, -2) + `{{${nextNumber}}}`;
      }
    }

    setBody(updatedVal);
  };


  return (
    <div className="mb-2 bg-white p-6 rounded-lg border">
      <h1 className="text-2xl">Content</h1>
      <p className="mb-6">
        Add a header, body and footer for your template. Cloud API hosted by
        Meta will review the template variables and content to protect the
        security and integrity of our services.
        <h3 className="text-blue-500">
          <a href="#">Learn more</a>
        </h3>
      </p>

      <div className="bg-white p-4">
        {/* Variable Type Selection */}
        <label className="block mb-1 font-bold p-2">
          Type of Variable
          <span className="relative inline-block ml-1 group">
            <span className="inline-flex justify-center w-3 h-3 text-xs font-bold text-white bg-black rounded-full cursor-pointer">
              i
            </span>
            <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 absolute top-full z-10 mt-2 px-4 py-3 text-sm text-black bg-white rounded-lg shadow-lg transition-all duration-200 w-72 text-left font-normal">
              <strong>
                <h3>Type of variable</h3>
              </strong>
              Variables are placeholders that are used to dynamically insert
              specific information or data into your template. You can insert
              either a name or number as a variable. Examples:
              {/* <li>Name: {"{{ order_id }}"}</li> */}
              <li>Number: {"{{1}}"}</li>
            </div>
          </span>
        </label>
        <div>
          <select
            className="w-1/3 p-3 border rounded mb-2 focus:outline-none focus:border-gray-400 focus:ring-2 focus:ring-gray-200"
            value={variableType}
            onChange={(e) => {
              setVariableType(e.target.value);
              setVarType(e.target.value);
              // Reset variable samples when type changes
              setVariableSamples({});
              // Re-validate when variable type changes
              setTimeout(() => {
                const headerValidation = validateVariables(header, 'header');
                const bodyValidation = validateVariables(body, 'body');
                const footerValidation = validateVariables(footer, 'footer');
                setValidation({
                  header: headerValidation,
                  body: bodyValidation,
                  footer: footerValidation
                });
              }, 0);
            }}
          >
            <option value="Number">Number</option>
            {/* <option value="Name">Name</option> */}
          </select>
        </div>

        {/* Media Section */}
        <label className="block font-bold p-2">
          Media sample <span className="text-gray-400">. Optional</span>
        </label>
        <select
          className="w-1/3 p-3 border rounded mb-2 focus:outline-none focus:border-gray-400 focus:ring-2 focus:ring-gray-200"
          value={mediaType}
          onChange={(e) => {
            setMediaType(e.target.value);
            if (e.target.value !== "None") {
              setHeader("");
            }
          }}
        >
          {["None", "Image", "Video", "Document"].map((sample) => (
            <option key={sample} value={sample}>
              {sample}
            </option>
          ))}
        </select>

        {/* Enhanced Media Upload Section */}
        {["Image", "Video", "Document"].includes(mediaType) && (
          <div className="mb-4">
            <div
              className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 cursor-pointer"
              onClick={() => document.getElementById("fileInput").click()}
            >
              <input
                id="fileInput"
                type="file"
                className="hidden"
                accept={
                  mediaType === "Image"
                    ? "image/png, image/jpeg"
                    : mediaType === "Video"
                      ? "video/mp4"
                      : ".pdf,.doc,.docx"
                }
                onChange={handleFileUpload}
              />

              {/* Enhanced Preview & Spinner */}
              {mediaFile ? (
                <div className="relative flex flex-col items-center space-y-2">
                  {isUploading ? (
                    // Spinner while uploading
                    <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  ) : mediaPreview ? (
                    mediaType === "Image" && mediaPreview !== "error" && mediaPreview !== "file" ? (
                      <img
                        src={mediaPreview}
                        alt="preview"
                        className="w-20 h-20 object-cover rounded"
                      />
                    ) : mediaType === "Video" && mediaPreview !== "error" && mediaPreview !== "file" ? (
                      <video
                        src={mediaPreview}
                        className="w-20 h-20 rounded"
                        muted
                      />
                    ) : mediaPreview === "error" ? (
                      <div className="flex items-center justify-center w-20 h-20 bg-red-100 text-red-600 text-xs rounded">
                        ❌ Error
                      </div>
                    ) : (
                      <div className="flex items-center justify-center w-20 h-20 bg-gray-100 text-gray-600 text-xs rounded">
                        📄 {mediaFile.name.slice(0, 8)}...
                      </div>
                    )
                  ) : null}

                  {/* Discard cross */}
                  {!isUploading && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDiscardMedia();
                      }}
                      className="absolute top-0 right-0 bg-white text-red-500 rounded-full shadow p-1 hover:bg-red-100"
                    >
                      ✕
                    </button>
                  )}

                  <p className="text-xs text-gray-600 font-medium">{mediaFile.name}</p>
                </div>
              ) : (
                <>
                  <p className="text-gray-600 font-medium">Drag and drop to upload</p>
                  <p className="text-gray-500 text-sm">
                    Or{" "}
                    <span className="text-blue-600 underline">
                      choose files on your device
                    </span>
                  </p>
                </>
              )}
            </div>
          </div>
        )}

        {/* Header Section */}
        <div>
          <label className="block font-bold p-2">
            Header <span className="text-gray-400">.Optional</span>
          </label>

          <div className="relative">
            <input
              value={header}
              onChange={(e) => setHeader(e.target.value)}
              className={`w-full p-2 border rounded focus:outline-none ${mediaType !== "None"
                ? "bg-gray-100 text-gray-400 cursor-pointer"
                : !validation.header.isValid
                  ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                  : "focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                }`}
              type="text"
              placeholder="Add a short line of text to the header of your message in English"
              maxLength={60}
              disabled={mediaType !== "None"}
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 bg-white px-1 pointer-events-none z-10">
              {header.length}/60
            </div>
          </div>

          {/* Header validation message */}
          {!validation.header.isValid && (
            <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-700 text-sm">{validation.header.message}</p>
            </div>
          )}

          {/* Add variable button */}
          <div className="flex justify-end pr-1">
            <div className="relative inline-block group">
              <button
                type="button"
                className="text-blue-900 text-sm mr-2"
                onClick={() => handleAddVariable("header")}
                disabled={mediaType !== "None"}
              >
                + Add variable
              </button>
              <span className="inline-flex justify-center w-3 h-3 text-xs font-bold text-white bg-black rounded-full cursor-pointer">
                i
              </span>
              <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 z-10 absolute top-full right-0 mt-2 px-4 py-3 text-sm text-black bg-white rounded-lg shadow-lg transition-all duration-200 w-72 text-left font-normal before:content-[''] before:absolute before:top-0 before:right-4 before:-translate-y-full before:border-8 before:border-transparent before:border-b-white">
                This is text that you specify in the API that will be
                personalised to the customer, such as their name or invoice
                number.
              </div>
            </div>
          </div>
        </div>

        {/* Body Section */}
        <label className="block font-bold p-2">Body</label>

        {/* Toolbar */}
        <div className="flex items-center gap-1 p-2 border border-b-0 rounded-t bg-gray-50">
          {/* Emoji */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              className="p-2 hover:bg-gray-200 rounded"
              title="Emoji"
            >
              <Smile size={18} className="text-gray-600" />
            </button>
            {showEmojiPicker && (
              <div className="absolute top-full left-0 mt-1 bg-white border rounded shadow-lg z-10 w-40 p-2 grid grid-cols-5 gap-1">
                {emojis.map((emoji, i) => (
                  <button
                    key={i}
                    onClick={() => addEmoji(emoji)}
                    className="text-lg hover:bg-gray-100 rounded"
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Format buttons */}
          <button
            onClick={() => applyFormat("bold")}
            className="p-2 hover:bg-gray-200 rounded"
          >
            <Bold size={18} className="text-gray-600" />
          </button>
          <button
            onClick={() => applyFormat("italic")}
            className="p-2 hover:bg-gray-200 rounded"
          >
            <Italic size={18} className="text-gray-600" />
          </button>
          <button
            onClick={() => applyFormat("underline")}
            className="p-2 hover:bg-gray-200 rounded"
          >
            <Underline size={18} className="text-gray-600" />
          </button>
          <button
            onClick={() => applyFormat("code")}
            className="p-2 hover:bg-gray-200 rounded"
          >
            <Code size={18} className="text-gray-600" />
          </button>

          {/* Count */}
          <div className="ml-auto text-sm text-gray-500">
            {body.length}/1024
          </div>
        </div>

        {/* Textarea */}
        <textarea
          id="bodyTextArea"
          value={body}
          // onChange={(e) => setBody(e.target.value)}
          onChange={handleBodyChange}
          maxLength={1024}
          className={`w-full h-40 border rounded-b focus:outline-none p-3 ${!validation.body.isValid
            ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-100"
            : "focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            }`}
          placeholder="Type your message..."
        />

        {/* Body validation message */}
        {/* {!validation.body.isValid && (
          <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-700 text-sm">{validation.body.message}</p>
          </div>
        )} */}

        {!validation.body.isValid && (
          <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            {/* {validation.body.errors.startEnd && (
              <p className="text-red-700 text-sm">
                Variables can't be at the start or end of the template.
              </p>
            )}

            {validation.body.errors.ratio && (
              <p className="text-red-700 text-sm">
                This template has too many variables for its length. Add more text or reduce variables.
              </p>
            )} */}
            {validation.body.errors.startEnd && (
              <p className="text-red-700 text-sm">
                Variables can't be at the start or end of the template.
              </p>
            )}

            {validation.body.errors.ratio && (
              <p className="text-red-700 text-sm">
                This template has too many variables for its length. Add more text or reduce variables.
              </p>
            )}

            {validation.body.errors.formatting && (
              <p className="text-red-700 text-sm">
                {validation.body.message}
              </p>
            )}
          </div>
        )}

        {/* Add variable */}
        <div className="flex justify-end pr-1">
          <div className="relative inline-block group">
            <button
              type="button"
              className="text-blue-900 text-sm mr-2"
              onClick={() => handleAddVariable("body")}
            >
              + Add variable
            </button>
            <span className="inline-flex justify-center w-3 h-3 text-xs font-bold text-white bg-black rounded-full cursor-pointer">
              i
            </span>
            <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 z-10 absolute top-full right-0 mt-2 px-4 py-3 text-sm text-black bg-white rounded-lg shadow-lg transition-all duration-200 w-72 text-left font-normal before:content-[''] before:absolute before:top-0 before:right-4 before:-translate-y-full before:border-8 before:border-transparent before:border-b-white">
              This is text that you specify in the API that will be personalised
              to the customer, such as their name or invoice number.
            </div>
          </div>
        </div>

        {/* Variable Samples Component*/}
        <SampleModel
          body={body}
          header={header}
          variableSamples={variableSamples}
          setVariableSamples={setVariableSamples}
          setBody={setBody}
          extractVariables={extractVariables}
        />

        {/* Footer Section */}
        <label className="block font-bold p-2">
          Footer <span className="text-gray-400">. Optional</span>
        </label>
        <div className="relative">
          <input
            value={footer}
            onChange={(e) => setFooter(e.target.value)}
            type="text"
            className={`w-full p-2 border rounded focus:outline-none ${!validation.footer.isValid
              ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-100"
              : "focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              }`}
            placeholder="Enter text"
            maxLength={60}
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 bg-white px-1 pointer-events-none z-10">
            {footer.length}/60
          </div>
        </div>

        {/* Footer validation message */}
        {!validation.footer.isValid && (
          <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-700 text-sm">{validation.footer.message}</p>
          </div>
        )}

      </div>
    </div>
  );
}

export default TemplateContent;